import { ProductCard } from "@kohler-dsm-library/kohler-core"
import productTileHOC from "@/components/Shared/ProductList/v2/ProductTile/V2/ProductTileHOC"

const ProductCardUI = props => {
  return <ProductCard {...props} />
}

export default productTileHOC(ProductCardUI)
